import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { AbstractControl, FormBuilder } from '@angular/forms';
import { StorageService } from '@morningstar/shared/base/storage-service';
import { select } from '@morningstar/shared/operators';
import { merge } from 'rxjs';
import { filter, pluck, startWith, tap } from 'rxjs/operators';
import { DashboardBaseComponent } from '../../dashboard-base/dashboard-base.component';
import { CheckInsSelectors } from '../check-ins.selectors';
import { CheckInsService } from '../check-ins.service';
import { CheckIns } from './check-ins';

@Component({
  selector: 'wsg-check-ins',
  templateUrl: './check-ins.component.html',
  styleUrls: ['./check-ins.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckInsComponent extends DashboardBaseComponent implements OnDestroy {

  // == CONSTANTS =======================================================

  title = 'Check-Ins';

  // == STATE ===========================================================

  form = this.formBuilder.group({
    location: '',
    date: new Date()
  });

  state$ = this.checkInsService.state$;

  // == INTERMEDIATE ====================================================
  
  date$ = this.date.valueChanges;
  location$ = this.location.valueChanges.pipe(
    startWith('')
  );
  
  checkIns$ = this.state$.pipe(select<CheckIns>(CheckInsSelectors.checkIns));
  
  guestCheckIns$ = this.checkIns$.pipe(pluck('guestCheckIns'));
  members$ = this.checkIns$.pipe(pluck('members'));
  guests$ = this.checkIns$.pipe(pluck('guests'));
  memberCheckIns$ = this.checkIns$.pipe(pluck('memberCheckIns'));

  // == SIDE EFFECTS ====================================================

  onGetCheckIns$ = merge(
    this.location$,
    this.date$
  ).pipe(
    filter(_ => !!this.location.value && !!this.date.value),
    tap(_ => this.checkInsService.getCheckIns(this.location.value, this.date.value))
  );

  // == SUBSCRIPTION ====================================================

  subscription = merge(
    this.onGetCheckIns$
  ).subscribe();

  // == LIFECYCLE =======================================================

  constructor(private checkInsService: CheckInsService,
              private formBuilder: FormBuilder,
              protected storageService: StorageService) {
    super(storageService);
  };

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  // == HELPERS =========================================================

  get location(): AbstractControl {
    return this.form.get('location');
  }

  get date(): AbstractControl {
    return this.form.get('date');
  }
}
